import moment from 'moment';
import _ from 'lodash';

export const getEndOfNextYear = _.memoize(() => {
  const endOfNextYear = moment().set('month', 1);
  endOfNextYear.add(1, 'year').set('month', 11).endOf('month');

  return endOfNextYear;
});
